/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'download': {
    width: 17,
    height: 17,
    viewBox: '0 0 17 17',
    data: '<path pid="0" d="M8.43 14.826a.54.54 0 00.16.113.58.58 0 00.387 0 .54.54 0 00.16-.113l4.573-4.567a.5.5 0 00-.706-.707l-3.72 3.687V1.326a.5.5 0 00-1 0v11.913l-3.72-3.713a.493.493 0 00-.707 0 .5.5 0 000 .706l4.573 4.594zM16.117 15.492H1.45a.5.5 0 000 1h14.667a.5.5 0 100-1z" _fill="#333"/>'
  }
})
